export const PAGE_COUNT = 20
export const MAX_FETCHED_LISTINGS = 2500
